<div class="page-container">
  <app-card>
    <div class="scrollable-content">
      <app-card-content class="flex-align-center">
        <div class="flex-column flex-align-center">
          <img [src]="'logos/app-logo-horizontal.png' | envPrefix" [attr.alt]="'app.title' | translate" class="home-logo"
            data-testid="home-logo" />
          <h2 class="m-auto-center" data-testid="home-heading">{{ 'home.welcome' | translate }}</h2>
          <div>{{ 'home.description' | translate }}</div>
        </div>
        @if (showOnboardingLink()) {
        <p class="onboarding-link-wrapper">
          <a routerLink="/onboarding" class="onboarding-link" data-testid="return-to-onboarding-link">
            {{ 'home.returnToGuide' | translate }}
          </a>
        </p>
        }
      </app-card-content>
      <app-card-actions>
        <app-button data-testid="my-day-button" variant="filled" routerLink="/my-day" *hasPermission="'interaction.read'">
          <app-icon name="sunrise" />
          {{ 'home.myDayButton' | translate }}
        </app-button>
        <app-button data-testid="addresses-button" variant="filled" routerLink="/map/addresses" *hasPermission="'address.read'">
          <app-icon name="map-pin" />
          {{ 'home.addressesButton' | translate }}
        </app-button>
        <app-button data-testid="map-button" variant="filled" routerLink="/map" *hasPermission="'address.read'">
          <app-icon name="map" />
          {{ 'home.mapButton' | translate }}
        </app-button>
        <app-button data-testid="leads-button" variant="filled" routerLink="/leads" *hasPermission="'lead.read'">
          <app-icon name="star" />
          {{ 'home.leadsButton' | translate }}
        </app-button>
        <app-button data-testid="reports-button" variant="outlined" routerLink="/reports" *hasPermission="'report.view'">
          <app-icon name="chart-no-axes-column-increasing" />
          {{ 'home.reportsButton' | translate }}
        </app-button>
      </app-card-actions>
    </div>
  </app-card>
</div>
